export default angular.module('field-wrapper', [])
  .directive('fieldWrap', function ($compile) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {},

      link: function(scope, el, attrs, ctrl) {
        scope.err = ctrl.$error;
        scope.hasError = false;

        scope.$watch('err', (value) => scope.hasError = !_.isEmpty(value) , true);

        var wrap = angular
          .element(`<div class="c-field layout__item tableize__cell u-ml-" ng-class="{'has-error': hasError, 'has-feedback': hasError}" style="width: 35%">`);

        var feedbacks = angular.element(
          `<div class="c-field__feedback has-tooltip ng-scope" ng-repeat="(error,value) in err">
            <svg role="img" class="o-icon o-icon--small">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-info"></use>
            </svg>
            <span class="c-tooltip c-tooltip--right" data-title="{{'$errors.'+error | translate}}"></span>
          </div>`);

        $compile(wrap)(scope);
        $compile(feedbacks)(scope);

        wrap.insertBefore(el);
        el.appendTo(wrap);
        feedbacks.appendTo(wrap);
      }
    };
  })



/** WEBPACK FOOTER **
 ** ./src/directives/fieldWrapper.js
 **/